import capitalize from "lodash/capitalize"
import { useTranslation } from "react-i18next"
import { useQueryState } from "@/hooks"
import type { TSession } from "@/types"
import { MultiFilter } from "./MultiFilter"

type Item = { value: TSession["state"]; label: string }
const filterName = "state"

export function StateFilter({
  states = ["pending", "in_progress", "finished"],
}: {
  states?: TSession["state"][]
} = {}) {
  const { t } = useTranslation()
  const [value = [], setValue] = useQueryState<string[]>(filterName)
  const items: Item[] = states.map((state) => ({
    value: state,
    label: capitalize(t(state.replace(/_/g, " "))),
  }))
  return <MultiFilter label={t("Filter by State")} value={value as string[]} setValue={setValue} items={items} />
}

StateFilter.useValue = () => {
  const [value] = useQueryState<string[]>(filterName)
  return value || []
}
